<template>
  <div class="main">
    <Nav />
  <section class="hero is-large is-primary is-bold hero-main">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        The UT Austin Digital Literacy Repository
      </h1>
      <h2 class="subtitle">
        A collection of resources for anyone interested in learning how to smartly navigate the digital age
      </h2>
      <router-link class="button is-white is-medium is-outlined" :to="{name:'resources'}">Get started</router-link>
    </div>
  </div>
</section>

<!--
<section class="hero is-light">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        What is Digital Literacy?
      </h1>
      <h2 class="subtitle">
        <p>The set of skills, knowledge, and attitudes required to access, create, use and evaluate digital information effectively, efficiently, and ethically.                    </p>                                                                                                                                                                    <p style="text-align:right; margin-top:1rem"><i>Heidi Julien</i></p>
      </h2>
    </div>
  </div>
</section>
  -->
<div class="columns" style="margin-top:2rem">
  <div class="column">
    <div class="card is-equal-height">
  <div class="card-image">
    <figure class="image is-4by3">
      <img src="../img/iste.png" alt="ISTE Standards">
    </figure>
  </div>
  <div class="card-content">
    <div class="media">
      
      <div class="media-content">
        <p class="title is-4">ISTE Standards</p>
      </div>
    </div>

    <div class="content">
      The ISTE Standards are an innovation framework that help educators and education leaders worldwide prepare learners to thrive in work and life. 
    </div>
  </div>
  <footer class="card-footer"><a href="https://www.iste.org/standards/for-educators" class="card-footer-item">Learn more</a></footer>

</div>
  </div>
  
  <div class="column">
    <div class="card is-equal-height">
  <div class="card-image">
    <figure class="image is-4by3">
      <img src="../img/find.png" alt="Find Videos">
    </figure>
  </div>
  <div class="card-content">
    <div class="media">
      
      <div class="media-content">
        <p class="title is-4">Find Resources</p>
      </div>
    </div>

    <div class="content">

Select your indicated category, audience and tag to get relevant resources...it's as easy as 1, 2, 3!
    </div>
    
  </div>
  <footer class="card-footer">
    <router-link class="card-footer-item" :to="{name:'resources'}">Get started</router-link>
    </footer>
</div>
  </div>
  
  <div class="column">
    <div class="card is-equal-height">
  <div class="card-image">
    <figure class="image is-4by3">
      <img src="../img/oii.png" alt="Office of Instructional Innovation">
    </figure>
  </div>
  <div class="card-content">
    <div class="media">
      
      <div class="media-content">
        <p class="title is-4">Who Are We?</p>
      </div>
    </div>

    <div class="content">
The Office of Instructional Innovation (OI2) offers College of Education instructors a broad range of technology integration services to achieve instructional or research objectives.      <br>
      
    </div>
  </div>
      <footer class="card-footer"><a href="https://education.utexas.edu/about/college-offices/office-instructional-innovation" class="card-footer-item">More about OI2</a></footer>

</div>
  </div>
  
</div>


    <Footer />
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  components: {
    Nav,
    Footer
  }
};
</script>

<style lang='scss'>
.hero.is-primary.is-bold .hero-body{
  opacity:1;
  background-image:linear-gradient(rgba(38, 72, 171, 0.8), rgba(255, 73, 92, 0.8)), url('../img/hero.jpg');
  background-size:cover;
  background-position:center center;
}

.hero-body .container{
  opacity:1;
}

.is-equal-height {
   display: flex;
   flex-direction: column;
   height: 100%;
}
.is-equal-height .card-footer {
  margin-top: auto;
}

</style>

